import { Navigate, Outlet } from 'react-router-dom';
import Homepage from "./Homepage";
import Entry from "./Entry";
import Auth from "./Auth";
import Form from './Form';

/*
const useAuth = () => {
    const user = { loggedIn: false };
    return user && user.loggedIn;
}

const ProtectedRoutes = () => {
    const isAuth = useAuth();
    return isAuth ? <Homepage/> : <Navigate to="/"/>;
};
*/
/*
const ProtectedRoutes = () => {
    return Auth.isAuthenticated ? <Outlet/> : <Navigate to="/"/>;
};
*/

const ProtectedRoutes = () => {
    //const isAuth = Auth;
    //return Auth.isAuthenticated() ? <Outlet/> : <Navigate to="/"/>;
    return <Outlet/>;
    
};

export default ProtectedRoutes;